<template>
    <div>
        <div style="border: 1px solid #eaeaea; width: 90%; margin: auto; margin-top: 20px; border-radius: 5px; background-color: #ffffff; overflow: hidden;">
            <div style="width: 290px; margin: auto; padding-top: 20px;">
                <vue-barcode :value="qrcode" height="80"></vue-barcode>
            </div>
            <div style="width:200px; margin: auto; padding: 10px 0 40px 0;">
                <div style="height: 200px;">
                    <qriously v-if="qrcode" :value="qrcode" :size="200" />
                </div>
            </div>
            <van-tabs type="card" style="margin-top: 10px;" @change="setPaymentMethod">
                <van-tab title="会 员 码" name="member">
                    <div class="member-pay">
                    </div>
                </van-tab>
                <van-tab title="卡 支 付" name="card">
                    <van-cell icon="debit-pay"
                            :title="currentPaymentMethod.payment_method === 'card' ? 'No.' + currentPaymentMethod.card_info.card_no : currentPaymentMethod.payment_method_name"
                            :value="currentPaymentMethod.payment_method === 'card' ? '￥' + currentPaymentMethod.card_info.balance : ''"
                            label="点击切换卡"
                            is-link
                            @click="showCard = true" style="border-top: 1px solid #efefef;margin-top: 15px;"/>
                </van-tab>
            </van-tabs>



            <van-popup v-model="showCard" position="bottom" style="height: 90%;">
                <div class="popup_tit">
                    <span>选择支付的卡</span>
                    <van-button type="info" size="small" @click="showCard = false">取 消</van-button>
                </div>
                <div class="card-list" style="padding-top: 20px;">
                    <div :class="{ 'card-item' : true, 'active' : index === selectPaymentIndex}" v-for="(item, index) in paymentMethod" :key="index" @click="selectPaymentMethod(index)">
                        <card-design v-if="item.payment_method === 'card'" :card-info="item.card_info"></card-design>
                        <div v-else class="other-card" :style="'background-image: url(' + item.background_image + ')'">
                            <span class="payment-method-name">{{item.payment_method_name}}</span>
                        </div>
                        <van-icon name="success" color="#ffffff" size="20"/>
                    </div>
                </div>
            </van-popup>

            <van-popup v-model="showPayCard" position="bottom" style="height: 90%;">
                <div class="popup_tit">
                    <span>选择支付的卡</span>
                    <van-button type="info" size="small" @click="showPayCard = false">取 消</van-button>
                </div>
                <div class="card-list" style="padding-top: 20px;">
                    <div :class="{ 'card-item' : true, 'active' : index === memberPaymentMethod}" v-for="(item, index) in paymentMethod" :key="index" @click="setPayCard(index)">
                        <card-design v-if="item.payment_method === 'card'" :card-info="item.card_info"></card-design>
                        <div v-else class="other-card" :style="'background-image: url(' + item.background_image + ')'">
                            <span class="payment-method-name">{{item.payment_method_name}}</span>
                        </div>
                        <van-icon name="success" color="#ffffff" size="20"/>
                    </div>
                </div>
            </van-popup>

            <van-popup v-model="showOrder" :closeable="paymentCodeStatus.mode === 'online'" position="bottom" :close-on-click-overlay="false" @close="orderClose" style="height: 90%;">
                <template v-if="showOrder">
                    <div style="margin-top: 50px; height: calc(100vh - 180px); overflow: auto;">
                        <div style="font-size: 20px; text-align: center;">
                            ￥<span style="font-size: 40px;">{{orderDetail.paid_amount}}</span>
                        </div>
                        <van-cell-group style="margin-top: 20px;">
                            <van-cell title="油品" :value="orderDetail.detail.oil_type.name"/>
                            <van-cell title="订单金额" :value="'￥' + orderDetail.total_amount"/>
                            <van-cell v-if="orderDetail.discount_amount > 0" title="总优惠" :value="'-￥' + orderDetail.discount_amount"/>
                            <van-cell v-if="isMember && paymentCodeStatus.mode === 'online'"
                            icon="debit-pay"
                            :title="orderParams.payment_method === 'card' ? 'No.' + paymentMethod[memberPaymentMethod].card_info.card_no : paymentMethod[memberPaymentMethod].payment_method_name"
                            :value="orderParams.payment_method === 'card' ? '￥' + paymentMethod[memberPaymentMethod].card_info.balance : ''"
                            label="点击切换支付方式" is-link @click="showPayCard = true" />
                            <!-- todo -->

                            <van-coupon-cell :coupons="couponList" :chosen-coupon="selectCouponIndex" @click="showCoupon = true" />
                        </van-cell-group>

                        <van-divider style="margin-top: 20px;" @click="showOrderDetail = !showOrderDetail">查看详情{{showOrderDetail ? '▲' : '▼'}}</van-divider>

                        <template v-if="showOrderDetail">
                            <van-cell-group title="订单信息">
                                <van-cell title="油量" :value="orderDetail.detail.oil_liter + ' L'"/>
                                <van-cell title="单价" :value="orderDetail.detail.oil_price + ' 元/L'"/>
                            </van-cell-group>
                            <van-cell-group v-if="orderDetail.discount_detail.length > 0" title="优惠">
                                <van-cell v-for="(discountItem, index) in orderDetail.discount_detail" :key="index" :title="discountItem.name">
                                    {{discountItem.value}}
                                </van-cell>
                            </van-cell-group>
                        </template>
                    </div>

                    <div style="padding: 10px 20px;">
                        <van-button type="primary" block @click="confirm" :loading="paying" :disabled="paying">确 定</van-button>
                    </div>
                </template>
            </van-popup>

            <van-popup v-model="showCoupon" round position="bottom" style="height: 90%; padding-top: 4px; overflow: hidden;">
                <van-coupon-list :coupons="couponList" :chosen-coupon="selectCouponIndex" :disabled-coupons="disabledCouponList" @change="couponChange" :show-exchange-bar="false" />
            </van-popup>
        </div>
        <div v-if="paymentCodeStatus.status === '2' || (paymentCodeStatus.mode === 'offline' && paymentCodeStatus.scan_code_parameter && !paymentCodeStatus.scan_code_parameter.is_fill_in_info)" class="wait-loading">
            <div style="position: relative; top: 50%; transform: translateY(-50%); text-align: center;">
                <van-loading color="#1989fa" />
                <div style="margin-top: 10px;">请付款</div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../assets/js/api";
    import CardDesign from "../../components/beilin/CardDesign";
    import common from "../../assets/js/common";
    import wx from "weixin-js-sdk";
    import VueBarcode from 'vue-barcode';
	import extend from 'extend';

    export default {
        name: "PaymentCode",
        components: {
            CardDesign,
            VueBarcode,
        },
        data(){
            return {
                showCard : false,
                showPayCard : false,
                showOrder : false,
                showCoupon : false,
                showOrderDetail : false,
                paymentMethod : [
                    {
                        payment_method : 'wechat_jsapi',
                        payment_method_name : '微信支付',
                        background_image : require('../../assets/images/wechat_jsapi_card.jpg'),
                    },
                ],
                selectPaymentIndex : 0,
                qrcode : '',
                refreshTimer : null,
                orderParams : {},
                orderDetail : {},
                userCoupon : [],
                selectCouponIndex : -2,
                paying : false,
                paymentCodeStatus : {},
                isMember : true,
                memberPaymentMethod : 0
            };
        },
        computed : {
            currentPaymentMethod(){
                return this.isMember === true ? {payment_method : 'member'} : this.paymentMethod[this.selectPaymentIndex];
            },
            couponList(){
                let list = this.userCoupon;
                let couponArr = [];
                for (let index in list){
                    let coupon = list[index];
                    if(!coupon['disabled']){
                        couponArr.push(common.convertCouponData(coupon));
                        if(coupon['is_select']){
                            this.selectCouponIndex = couponArr.length - 1;
                        }
                    }
                }
                return couponArr;
            },
            disabledCouponList(){
                let list = this.userCoupon;
                let couponArr = [];
                for (let index in list){
                    let coupon = list[index];
                    if(coupon['disabled']){
                        couponArr.push(common.convertCouponData(coupon));
                    }
                }
                return couponArr;
            },
			orderAPIParams() {
				console.log(typeof this.orderParams.user_card_id === 'string', this.orderParams.user_card_id, extend(true, {}, this.orderParams, {user_card_id: [this.orderParams.user_card_id]}))
				console.log(this.orderParams.user_card_id && typeof this.orderParams.user_card_id === 'string')
				if(this.orderParams.user_card_id && typeof this.orderParams.user_card_id === 'string') {
					return extend(true, {}, this.orderParams, {user_card_id: [this.orderParams.user_card_id]})
				}
				return this.orderParams
			}
        },
        watch : {
            currentPaymentMethod:{
                handler(newValue, oldValue){
                    this.refresh();
                },
                deep: true
            },
            selectCouponIndex(newValue, oldValue){
                this.refreshOrder();
            },
        },
        created() {
            let self = this;
            self.refresh();
            api.request('/user_card/list').then(res => {
                for(let index in res.data){
                    self.paymentMethod.push({
                        payment_method : 'card',
                        payment_method_name : '卡支付',
                        card_info : res.data[index],
                    });
                    if(res.data[index]['is_default'] === true){
                        self.selectPaymentIndex = self.paymentMethod.length - 1;
                        self.memberPaymentMethod = self.paymentMethod.length - 1;
                    }
                }
            });

            let statusTimer = setInterval(function () {
                api.request('/user/get_payment_code_status').then(res => {
                    self.paymentCodeStatus = res.data;

                    if(res.data.status === '3'){
                        if(statusTimer) {
                            clearInterval(statusTimer);
                        }
                        self.$toast.success({
                            message: '支付成功',
                        });
                        // 跳转到订单页面
                        self.$router.push({
                            name: 'ConsumeDetail',
                            query : {
                                orderNo: res.data.success_result.order_no,
                            }
                        });
                        return;
                    }
                    // 已扫码
                    if(res.data.code === self.qrcode && res.data.status === '1' && self.showOrder === false){
                        if(self.refreshTimer) {
                            clearTimeout(self.refreshTimer);
                            self.refreshTimer = null;
                        }

                        if(res.data.mode === 'offline' && !res.data.scan_code_parameter.is_fill_in_info) return;  //不需要填写，直接返回

                        self.orderParams = {
                            site_oil_gun_id: res.data.scan_code_parameter.site_oil_gun_id, // 油枪ID
                            order_id: res.data.scan_code_parameter.order_id, // 订单ID
                            payment_method: self.isMember ? (self.paymentCodeStatus.mode == 'online' ? self.paymentMethod[self.memberPaymentMethod].payment_method : 'member') : res.data.payment_method, // 支付方式
                            user_card_id: self.isMember ? (self.paymentCodeStatus.mode === 'online' && self.paymentMethod[self.memberPaymentMethod].payment_method === 'card' ? self.paymentMethod[self.memberPaymentMethod].card_info.id : '') : (res.data.payment_parameter && res.data.payment_parameter.card_id), // 卡片ID
                        };
                        self.refreshOrder();
                        self.showOrder = true;
                    }else if(res.data.code === self.qrcode && res.data.status === '2' && self.refreshTimer){
                        clearTimeout(self.refreshTimer);
                        self.refreshTimer = null;
                    }
                });
            }, 2000);
        },
        methods : {
            setPayCard(index) {
                this.showPayCard = false;
                this.memberPaymentMethod = index;
                this.orderParams.payment_method = this.paymentMethod[this.memberPaymentMethod].payment_method  // 支付方式
                if (this.orderParams.payment_method === 'card') {
                    this.orderParams.user_card_id = this.paymentMethod[this.memberPaymentMethod].card_info.id  // 卡片ID
                }
                this.refreshOrder();
            },
            setPaymentMethod(name, title) {
                this.isMember = name === 'member' ? true : false;
            },
            selectPaymentMethod(index){
                this.selectPaymentIndex = index;
                this.showCard = false;
            },
            refresh(){
                let self = this;
                api.request('/user/get_payment_code', {
                    payment_method : this.currentPaymentMethod.payment_method,
                    card_id : this.currentPaymentMethod.payment_method === 'card' ? this.currentPaymentMethod.card_info.id : undefined,
                }).then(res => {
                    self.qrcode = res.data.code;
                    if(self.refreshTimer) {
                        clearTimeout(self.refreshTimer);
                        self.refreshTimer = null;
                    }
                    self.refreshTimer = setTimeout(self.refresh, 55 * 1000);
                }).catch(res => {

                });
            },
            refreshOrder(){
                let self = this;
                self.orderParams.user_coupon_id = self.couponList[self.selectCouponIndex] ? self.couponList[self.selectCouponIndex]['info']['id'] : (self.selectCouponIndex === -2 ? '' : undefined);
                let orderParams = extend(true, {}, self.orderParams);
				if (orderParams.user_card_id) {
					orderParams.user_card_id = [orderParams.user_card_id];
				};
				api.request('/order/checkout', orderParams).then(res => {
                    for(let index in res.data.order_detail.discount_detail){
                        if(res.data.order_detail.discount_detail[index]['name'] === '优惠券优惠'){
                            res.data.order_detail.discount_detail.splice(index, 1);
                        }
                    }

                    self.orderDetail = res.data.order_detail;
                    self.userCoupon = res.data.user_coupon;
                }).catch(err => {
                    this.$notify({ type: 'danger', message: err.msg })
                }).finally(() => {
                    //this.isLoading = false
                })
            },
            couponChange(index){
                this.selectCouponIndex = index;
                this.showCoupon = false;
            },
            orderClose(){
                if(this.paymentCodeStatus.mode === 'online') {
                    this.refresh();
                }
            },
            confirm(){
                let self = this;

                if(self.paymentCodeStatus.mode === 'online'){
                    self.paying = true;
                    api.request('/order/payment', Object.assign({}, {
                        payment_code : self.qrcode,
                    }, self.orderAPIParams)).then(res => {
                        if(this.payType === 'card' || !res.data.payment_info){
                            this.$toast.success({
                                message: '支付成功',
                                onClose(){
                                    // 跳转到订单页面
                                    self.$router.push({
                                        name: 'ConsumeDetail',
                                        query : {
                                            orderNo: res.data.order_no,
                                        }
                                    });
                                },
                            });
                        }else if(this.payType === 'wechat_jsapi'){
                            let payInfo = JSON.parse(res.data.payment_info);
                            common.wechatPayReady(payInfo.appId, () => {
                                wx.chooseWXPay({
                                    timestamp: payInfo.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                                    nonceStr: payInfo.nonceStr, // 支付签名随机串，不长于 32 位
                                    package: payInfo.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                                    signType: payInfo.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                                    paySign: payInfo.paySign, // 支付签名
                                    // 支付成功后的回调函数
                                    success: (res) => {
                                        self.$toast.success({
                                            message: '支付成功',
                                            onClose () {
                                                // 跳转到订单页面
                                                self.$router.push({
                                                    name: 'ConsumeDetail',
                                                    query: {
                                                        orderNo: res.data.order_no,
                                                    }
                                                });
                                            }
                                        });
                                    },
                                    cancel () {
                                        // 跳转到订单页面
                                        self.$router.push({
                                            name: 'ConsumeDetail',
                                            query: {
                                                orderNo: res.data.order_no,
                                            }
                                        });
                                    },
                                    fail: (err) => {
                                        self.$notify({type: 'danger', message: err.errMsg});
                                    },
                                });
                            });
                        }
                    }).catch(err => {
                        self.$notify(err.msg);
                    }).finally(() => {
                        self.paying = false;
                    });
                }else if(self.paymentCodeStatus.mode === 'offline'){
                    self.paying = true;
                    api.request('/user/payment_code_fill_in_info', {
                        fill_in_info : {
                            user_coupon_id : self.couponList[self.selectCouponIndex] ? self.couponList[self.selectCouponIndex]['info']['id'] : (self.selectCouponIndex === -2 ? '' : undefined),
                        },
                    }).then(res => {
                        self.$notify({ type: 'success', message: res.msg });
                        self.showOrder = false;
                    }).catch(res => {
                        self.$notify({ type: 'danger', message: res.msg });
                    }).finally(() => {
                        self.paying = false;
                    });
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .member-pay {
        display: flex;
        height: 10px;
        padding:10px 0;
        width: 100%;
        color: #999;
        font-size: 16px;
        justify-content: center;
        align-items: center;
    }
    .wait-loading{
        background-color: #ffffff;
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0.8;
    }
    .other-card{
        width: 290px;
        height: 160px;

        .payment-method-name{
            font-size: 30px;
            color: #ffffff;
            margin-left: 20px;
            margin-top: 10px;
            display: inline-block;
        }
    }
    .card-list{
        .card-item{
            width: 290px;
            margin: auto auto 20px;
            position: relative;
            border-radius: 15px;
            overflow: hidden;
            border: 3px solid transparent;
            box-sizing: border-box;

            i {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 0;
                height: 0;
                border-top: transparent solid 20px;
                border-left: transparent solid 20px;
                border-bottom: #07c160 solid 20px;
                border-right: #07c160 solid 20px;
                display: none;
            }

            i:before {
                position: absolute;
                right: -18px;
                bottom: -18px;
                display: block;
                transform: rotate(-30deg);
            }

            &.active{
                border: 3px solid #07c160;
                i{
                    display: block;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/PaymentCode.vue